import { Settings } from 'pages';
import AuditDetailPage from 'pages/audits/[id]/page';
import Audits from 'pages/audits/page';
import CustomerView from 'pages/customers/[id]/page';
import Customers from 'pages/customers/page';
import DailyReport from 'pages/daily-report/[id]/page';
import DistributionCenter from 'pages/distribution-center/[id]/page';
import FinalCompletionReport from 'pages/final-completion-report/[id]/page';
import StoresView from 'pages/stores/[id]/page';
import TechRepChecklist from 'pages/techrep-checklist/[id]/page';
import Users from 'pages/users/page';
import Forms from 'pages/forms/page';
import ManageCustomer from 'pages/ManageCustomer/page';
import ViewCustomer from 'pages/ViewCustomer/page';
import UpdateFormLabels from 'pages/UpdateFormLabels';

export const admin_role_id = 2

export const roomOptions = [
  { label: 'Room#1', value: 'Room#1' },
  { label: 'Room#2', value: 'Room#2' },
  { label: 'Room#3', value: 'Room#3' },
];

export const formItems = [
  { id: 1, title: 'TechRep Checklist', route: '/forms-tech-reps' },
  { id: 2, title: 'Distribution Centre - Rooms', route: '/forms-distribution-center-rooms' },
  { id: 3, title: 'Stores', route: '/forms-stores' },
  { id: 4, title: 'Additional Notes', route: '/forms-additional-notes' },
];

export const storeTabFields = {
  'General': [
    { placeholder: 'Store Name' },
    { placeholder: 'Store Number' },
    { placeholder: 'Store Address' },
    { placeholder: 'Store Contacts' },
    { placeholder: 'Store Feedback' },
  ],

  'Retail Display': [
    { placeholder: 'CV Label' },
    { placeholder: 'Country of Origin' },
    { placeholder: 'Farm Code' },
    { placeholder: 'CV Label 2' },
    { placeholder: 'Country of Origin 2' },
    { placeholder: 'Farm Code 2' },
    { placeholder: 'Price' },
    { placeholder: 'Display Quality' },
    { placeholder: 'Defects' },
    { placeholder: 'Layers' },
    { placeholder: 'Fruit Under Display' },
    { placeholder: 'Fullness' },
    { placeholder: 'Average Color' },
    { placeholder: 'Pad Type' },
  ],

  'Organic Display': [
    { placeholder: 'OG Label' },
    { placeholder: 'Country of Origin' },
    { placeholder: 'Price' },
    { placeholder: 'Defects' },
    { placeholder: 'Average Color' },
    { placeholder: 'Display Quality' },
  ],

  'Backroom': [
    { placeholder: 'Number of Boxes' },
    { placeholder: 'Box Code' },
    { placeholder: 'Cold Source' },
    { placeholder: 'Heat Source' },
    { placeholder: 'Ambient Temperature' },
    { placeholder: 'Shroud Removed' },
    { placeholder: 'Uncapped' },
    { placeholder: 'Cross Stacked' },
    { placeholder: 'CV Quality' },
    { placeholder: 'Load Arrival Date' },
    { placeholder: 'Pulp Temperature' },
    { placeholder: 'Average Color' },
    { placeholder: 'Defects' },
    { placeholder: 'OG Quality' },
  ],

  'Specialty Display': [
    { placeholder: 'Specialty Item' },
    { placeholder: 'Brand' },
    { placeholder: 'Country' },
    { placeholder: 'Price' },
    { placeholder: 'Quality' },
    { placeholder: 'Defects' },
    { placeholder: 'Attachments' },
  ],

  'Secondary Display': [
    { placeholder: 'Location' },
    { placeholder: 'Fullness' },
    { placeholder: 'Quality' },
    { placeholder: 'Average Color' },
  ],
};

export const storeTabs = [
  'General',
  'Retail Display',
  'Organic Display',
  'Backroom',
  'Specialty Display',
  'Secondary Display',
];

export const techRepTabs = [
  'Review Previous Report',
  'Contract Sales Rep for Account',
  'Contact Port QA Manager',
  'Contact Buyer/Ripener',
  'Observe Room Checks',
  'Observe Arrival Inspections',
  'Observe Box/Pallet Quality',
  'Observe Staging/Selection',
  'Complete Room Inspections',
  'Others',
];

export const techRepTabFields = {
  'Review Previous Report': [
    { placeholder: 'Identify Main Issues' },
    { placeholder: 'Compare Results from Previous and Current Reports' },
  ],
  'Contract Sales Rep for Account': [
    { placeholder: 'Sales Rep' },
    { placeholder: 'Basic Account information' },
    { placeholder: 'Issues (Rejections/Complaints)' },
    { placeholder: 'Contact Name' },
    { placeholder: 'Contact Number' },
    { placeholder: '# of loads/week and Dates of Arrival' },
    { placeholder: 'Country/Countries of Origin of Receiving Fruit:' },

  ],
  'Contact Port QA Manager': [
    { placeholder: 'Discuss Quality of fruit Being Received by the Customer' },

  ],
  'Contact Buyer/Ripener': [
    { placeholder: 'Ripener Name' },
    { placeholder: 'Ripener Number' },
    { placeholder: 'Ripener E-mail' },
    { placeholder: 'Type of Rooms' },
    { placeholder: '# of Rooms' },
    { placeholder: 'Age of Rooms' },
    { placeholder: 'Warehouse Address/Getting in (Guard, shack info, etc.)' },
    { placeholder: 'Time/Date to be at the Warehouse' },
    { placeholder: 'Time Room Checks are Preformed' },
    { placeholder: 'Time/Dates of Load Arrivals' },


  ],
  'Observe Room Checks': [
    { placeholder: '# of Room Checks/Day' },
    { placeholder: 'Room Check Morning Observations' },
    { placeholder: 'Room Check Afternoon Observation' },
    { placeholder: 'Ripening Cycle' },
    { placeholder: 'Venting Cycle' },
    { placeholder: 'Target Color' },
  ],

  'Observe Arrival Inspections': [
    { placeholder: 'Date/Time of Observation' },
    { placeholder: 'Receiving Dock Temperature' },
    { placeholder: 'Arrival Inspection Observations' },

  ],
  'Observe Box/Pallet Quality': [
    { placeholder: 'Comment' },
    { placeholder: 'Attachments' },
  ],
  'Observe Staging/Selection': [
    { placeholder: 'Date/Time of Observation' },
    { placeholder: 'Selection Handling Observation' },
    { placeholder: 'Pallet' },
    { placeholder: 'Plastic Shroud' },
    { placeholder: 'Shrink Wrap' },
    { placeholder: 'Staging Area Ambient Temp' },
    { placeholder: 'Outbound Color' },
    { placeholder: 'Staging Time' },
    { placeholder: 'Pulp Temps at Staging (3)' },
    { placeholder: 'Loading Dock Ambient Temp' },
    { placeholder: 'Pulp Temps at Selection (3)' },
    { placeholder: 'Time on Dock' },
    { placeholder: 'Truck Temperature' },
    { placeholder: 'Attachments' },


  ],
  'Complete Room Inspections': [
    { placeholder: 'Room Capacity' },
    { placeholder: 'Type of Doors' },
    { placeholder: 'Type of Humidification System' },
    { placeholder: 'Type of Ethylene Generator' },
    { placeholder: 'Complete Daily Updates' },

  ],

  'Others': [
    { placeholder: 'Send Itinerary' },
    { placeholder: 'Perform PCMS' },
  ],


};

export const roomsTabs = ['Room Setup', 'Reading', 'Structural', 'Sanitation'];

export const roomsTabFields = {
  'Room Setup': [
    { placeholder: 'Manufacturer' },
    { placeholder: 'Door Type' },
    { placeholder: 'Room Style' },
    { placeholder: 'Room Commodity' },
    { placeholder: 'Temp Control Type' },

  ],
  'Reading': [
    { placeholder: 'Setpoints' },
    { placeholder: 'Sensor Reading' },
    { placeholder: 'Actual Reading' },
    { placeholder: 'Humidifier Function' },
    { placeholder: 'Air Pressure' },
    { placeholder: 'Vent Function' },
    { placeholder: 'Room Loading' },

  ],
  'Structural': [
    { placeholder: 'Location' },
    { placeholder: 'Severity' },
    { placeholder: 'Quantity' },
    { placeholder: 'Attachments' },
    { placeholder: 'Caption' },
  ],
  'Sanitation': [
    { placeholder: 'Location' },
    { placeholder: 'Severity' },
    { placeholder: 'Attachments' },
    { placeholder: 'Caption' },
  ],
};


export const reports = [
  {
    type: 'Daily Report Day 1',
    generatedOn: 'Aug 10, 2025',
    format: 'Word',
    submittedby: 'John Doe',
    emailAddresses: ['123@gmail.com', 'abc@gmail.com'],
    emailSent: 'Yes',
    status: 'Completed',
    submittedBy: {
      label: '03 out of 04',
      users: [
        { id: 1, name: 'Sarah Watson', isCompleted: true },
        { id: 2, name: 'Mark William', isCompleted: true },
        { id: 3, name: 'Clarissa Reilly', isCompleted: true },
        { id: 4, name: 'Syed Ibrahim', isCompleted: false },
      ],
    }
  },
  {
    type: 'Daily Report Day 2',
    generatedOn: 'Aug 15, 2025',
    format: 'Word',
    submittedby: 'Jane Smith',
    emailAddresses: ['123@gmail.com'],
    emailSent: 'No',
    status: 'Pending',
    submittedBy: {
      label: '03 out of 04',
      users: [
        { id: 1, name: 'Sarah Watson', isCompleted: true },
        { id: 2, name: 'Mark William', isCompleted: true },
        { id: 3, name: 'Clarissa Reilly', isCompleted: true },
        { id: 4, name: 'Syed Ibrahim', isCompleted: false },
      ],
    }
  },
  {
    type: 'Completion Report',
    generatedOn: 'Aug 15, 2025',
    format: 'Word',
    emailAddresses: ['123@gmail.com'],
    emailSent: 'No',
    status: 'Completed',
    submittedBy: {
      label: '03 out of 04',
      users: [
        { id: 1, name: 'Sarah Watson', isCompleted: true },
        { id: 2, name: 'Mark William', isCompleted: true },
        { id: 3, name: 'Clarissa Reilly', isCompleted: true },
        { id: 4, name: 'Syed Ibrahim', isCompleted: false },
      ],
    }
  },
  {
    type: 'Final Audit Report',
    generatedOn: 'Aug 15, 2025',
    format: 'PowerPoint',
    emailAddresses: ['abc@gmail.com'],
    emailSent: 'Yes',
    status: 'Pending',
    submittedBy: {
      label: '03 out of 04',
      users: [
        { id: 1, name: 'Sarah Watson', isCompleted: true },
        { id: 2, name: 'Mark William', isCompleted: true },
        { id: 3, name: 'Clarissa Reilly', isCompleted: true },
        { id: 4, name: 'Syed Ibrahim', isCompleted: false },
      ],
    }
  },
];


export const routes = [
  {
    path: '/users',
    component: Users,
  },
  {
    path: '/audits',
    component: Audits,
  },
  {
    path: '/audits/:id',
    component: AuditDetailPage,
  },
  {
    path: '/customers',
    component: Customers,
  },
  {
    path: '/customers/:id',
    component: CustomerView,
  },
  {
    path: '/daily-report/:id',
    component: DailyReport,
  },
  {
    path: '/distribution-center/:id',
    component: DistributionCenter,
  },
  {
    path: '/final-completion-report/:id',
    component: FinalCompletionReport,
  },
  {
    path: '/stores/:id',
    component: StoresView,
  },
  {
    path: '/techrep-checklist/:id',
    component: TechRepChecklist,
  },
  {
    path: '/settings',
    component: Settings,
  },
  {
    path: '/forms',
    component: Forms,
  },
  {
    path: '/forms/update-form-labels',
    component: UpdateFormLabels,
  },
  {
    path: '/manage-customer',
    component: ManageCustomer,
  },

  {
    path: '/view-customer',
    component: ViewCustomer,
  },

];


